<template>
 <div class="show-handle-result-dialog">
    <el-dialog :title="title" :visible.sync="visible" :before-close="close" width="75%" :append-to-body='true'>
      <div v-loading='loading' element-loading-text='拉取数据中...'>
        <p class="tip" v-if="status === '上传数据'">共上传 {{totalNum}} 份数据，其中操作成功 {{successNum}} 份数据，处理失败<span class="red"> {{Number(totalNum)- Number(successNum)}} </span>份数据</p>
        <p class="tip" v-else>共 {{totalNum}} 个订单，其中操作成功 {{successNum}} 个订单，失败<span class="red"> {{Number(totalNum)- Number(successNum)}} </span>个订单</p>
          <wt-table :list="tableData" :labels="currentLabels" max-height="500" :row-class-name="setRed" >
              <el-table-column type="index" width="50" slot="before">
              </el-table-column>
              <el-table-column label="操作">
                  <template slot-scope="scope">
                      <el-button type="text" @click="goDetail(scope.row.orderId)">详情</el-button>
                  </template>
              </el-table-column>
          </wt-table>
          <div class="marginTop">
              <el-button type="primary" @click="close">关闭</el-button>
          </div>
      </div>
    </el-dialog>
 </div>
</template>

<script>
import { getCurrentLables } from 'cps/lab-order/show-handle-result-dialog/handle-options'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 是否显示原因列
    isShowReason: {
      type: Boolean,
      default: false
    },
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    status: {
      type: String,
      default: ''
    }
  },
  watch: {
    dialogVisible (val) {
      this.visible = val
    }
  },
  computed: {
    totalNum () {
      return this.tableData.length
    },
    successNum () {
      let suc = this.tableData.filter(e => e.successful).length
      return suc
    },
    currentLabels () {
      let current = getCurrentLables(this.isShowReason, this.status)
      return current
    },
    title () {
      return `本次${this.status}批量操作已提交`
    }
  },
  data () {
    return {
      loading: false,
      visible: this.dialogVisible
    }
  },
  methods: {
    dealLoading (val) {
      this.loading = val
    },
    close () {
      this.$emit('updateVisible', false)
    },
    goDetail (id) {
      this.$router.push({ name: 'lab-order-detail', params: { id: id } })
    },
    setRed ({ row, rowIndex }) {
      if (!row.successful) {
        return 'red'
      }
      return ''
    }
  }
}
</script>

<style lang="less">
.show-handle-result-dialog{
  .red{
    color: red;
  }
  .tip{
    font-weight: 500;
  }
  .el-dialog__body{
    padding-top:0;
  }
}
</style>
